<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     :btn_copy = "can_copy"
                     @copy="handleCopy"
                     :btn_add = "can_add"
                     :btn_edit = "can_edit"
                     :btn_delete = "can_delete"
        >
        </front-table>
        <!--编辑界面-->
        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields" dual
                     @success="handleSuccess" @cancel="handleCancel"></edit-dialog>

        <div class="clearfix"></div>
    </section>
</template>

<script>
    import EditDialog from "../components/edit-dialog";
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";

    export default {
        mixins: [FrontMixins],
        name: 'admin-admin',
        components: {FrontTable, EditDialog},
        created() {
            this.model =  'Admin.' + this.$route.meta.model;
        },
        computed:{
            can_copy(){
                return this.$route.meta?this.$route.meta.copy:false;
            },
            can_add(){
                return this.$route.meta?this.$route.meta.add:true;
            },
            can_edit(){
                return this.$route.meta?this.$route.meta.edit:true;
            },
            can_delete(){
                return this.$route.meta?this.$route.meta.delete:true;
            }
        }
    }

</script>

<style lang="scss">

</style>
